<template>
  <div>
    <b-select v-model="selectedSurvey" :placeholder="$t('optional')">
      <option v-for="(survey, key) in filteredSurveys" :key="key" :value="{ title: survey.title, code: survey.code }">
        {{ survey.title }}
      </option>
    </b-select>
  </div>
</template>

<script>
import { db } from "@/firebase";
export default {
  name: "SurveyChooser",
  data() {
    return {
      surveys: null,
    };
  },
  computed: {
    filteredSurveys() {
      return this.surveys.filter((y) => y.title && !y.closed);
    },
    selectedSurvey: {
      get() {
        return this.$store.state.draft.survey;
      },
      set(value) {
        this.$store.commit("SET_DRAFT_FIELD", ["survey", { title: value.title, code: value.code }]);
      },
    },
  },
  firestore() {
    return {
      surveys: db.collection("surveys").where("organizationId", "==", this.$route.params.organizationId),
    };
  },
};
</script>

<style></style>
